module.exports = __webpack_public_path__ + "static/car-ebee2a5c2156b8cf12d061dd0c7da3bd.jpg";